module.exports = __webpack_public_path__ + "img/0Q3B3814-26_H_Black.b3ccf6ba.jpg";